<template>
	<div
		class="grid-container grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-white mt-4 mb-44"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
